import React from 'react';

import {ProteinComplex} from 'molbio/proteins/complex/ProteinComplexConstants';
import formatAminoAcids from 'molbio/proteins/util/formatAminoAcids';

export default function ProteinChainPreview({name, aminoAcids}: ProteinComplex): JSX.Element {
  return (
    <div>
      <div>
        <strong>{name}</strong>
      </div>
      <pre>{formatAminoAcids(aminoAcids)}</pre>
    </div>
  );
}
